import { render, staticRenderFns } from "./FormPlacement.vue?vue&type=template&id=151c12c2&"
import script from "./FormPlacement.vue?vue&type=script&lang=js&"
export * from "./FormPlacement.vue?vue&type=script&lang=js&"
import style0 from "./FormPlacement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports